import React, { useEffect, useState } from "react";
import { TabContent, TabPane } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import {
  addJobPrioritySuccess,
  addJobStatusSuccess,
  addJobTypeSuccess,
  addNewJobPriority,
  addNewJobStatus,
  addNewJobType,
  deleteJobPriority,
  deleteJobPrioritySuccess,
  deleteJobStatus,
  deleteJobType,
  deleteJobTypeSuccess,
  getJobsPriorityData,
  getJobStatusData,
  getJobsTypeData,
  updateJobPriority,
  updateJobPrioritySuccess,
  updateJobStatus,
  updateJobStatusSuccess,
  updateJobType,
  updateJobTypeSuccess,
} from "../../../../store/jobsList/actions";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";
import { toast } from "react-toastify";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import BillableItemsTemplates from "./BillableItemsTemplates";
import JobTags from "./JobTags";
import JobSheets from "./JobSheets";
export default function JobSettings() {
  const dispatch = useDispatch();
  const { jobStatusListApi } = useSelector((state) => ({
    jobStatusListApi: state.Jobs.jobStatusData?.jobstatus_list,
  }));
  const { jobsTypeList } = useSelector((state) => ({
    jobsTypeList: state.Jobs.jobTypeList?.jobtype_list,
  }));

  const { jobPriorityList } = useSelector((state) => ({
    jobPriorityList: state.Jobs.jobPriorityList?.jobpriority_list,
  }));
  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [statusFlag, setStatusFlag] = useState(false);
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    FlagActive: null,
    FlagInvoiceable: null,
  });
  const [updateItemStatus, setUpdateItemStatus] = useState({});
  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      // Job Status create
      dispatch(addNewJobStatus([createStatus]));
    }
    if (activeTab === "2") {
      // Job Type create
      dispatch(addNewJobType([createStatus]));
    }
    if (activeTab === "3") {
      // Job Priority create
      dispatch(addNewJobPriority([createStatus]));
    }
  };
  // Job Status create
  const { jobStatusCreateSuccessAPI } = useSelector((state) => ({
    jobStatusCreateSuccessAPI: state.Jobs.jobStatusCreateSuccess,
  }));

  useEffect(() => {
    if (isEmpty(jobStatusCreateSuccessAPI)) return;
    if (jobStatusCreateSuccessAPI.status === 200) {
      toast.success(jobStatusCreateSuccessAPI.message);
      dispatch(getJobStatusData());
      setCreateStatus({
        Name: "New Status",
        CssColourText: "#000000",
        CssColourBackground: "#F4F0F0",
        FlagActive: null,
        FlagInvoiceable: null,
      });
    } else {
      toast.error(jobStatusCreateSuccessAPI.message);
    }
    dispatch(addJobStatusSuccess([]));
  }, [jobStatusCreateSuccessAPI]);
  // Job Type create

  const { jobTypeCreateSuccessAPI } = useSelector((state) => ({
    jobTypeCreateSuccessAPI: state.Jobs.jobTypeCreateSuccess,
  }));

  useEffect(() => {
    if (isEmpty(jobTypeCreateSuccessAPI)) return;
    if (jobTypeCreateSuccessAPI.status === 200) {
      toast.success(jobTypeCreateSuccessAPI.message);
      dispatch(getJobsTypeData());
      setCreateStatus({
        Name: "New Status",
        CssColourText: "#000000",
        CssColourBackground: "#F4F0F0",
        FlagActive: null,
        FlagInvoiceable: null,
      });
    } else {
      toast.error(jobTypeCreateSuccessAPI.message);
    }
    dispatch(addJobTypeSuccess([]));
  }, [jobTypeCreateSuccessAPI]);

  // Job Priority create
  const { jobPriorityCreateSuccessAPI } = useSelector((state) => ({
    jobPriorityCreateSuccessAPI: state.Jobs.jobPriorityCreateSuccess,
  }));

  useEffect(() => {
    if (isEmpty(jobPriorityCreateSuccessAPI)) return;
    if (jobPriorityCreateSuccessAPI.status === 200) {
      toast.success(jobPriorityCreateSuccessAPI.message);
      dispatch(getJobsPriorityData());
      setCreateStatus({
        Name: "New Status",
        CssColourText: "#000000",
        CssColourBackground: "#F4F0F0",
        FlagActive: null,
        FlagInvoiceable: null,
      });
    } else {
      toast.error(jobPriorityCreateSuccessAPI.message);
    }
    dispatch(addJobPrioritySuccess([]));
  }, [jobPriorityCreateSuccessAPI]);

  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      // Job Status delete
      dispatch(deleteJobStatus([deleteStatus]));
    }
    if (activeTab === "2") {
      // Job Type delete
      dispatch(deleteJobType([deleteStatus]));
    }
    if (activeTab === "3") {
      // Job Priority delete
      dispatch(deleteJobPriority([deleteStatus]));
    }
  };

  // Delete Job Status
  const { jobStatusDeleteAPI } = useSelector((state) => ({
    jobStatusDeleteAPI: state.Jobs.jobStatusDelete,
  }));

  useEffect(() => {
    if (isEmpty(jobStatusDeleteAPI)) return;
    if (jobStatusDeleteAPI.status === 200) {
      toast.success(jobStatusDeleteAPI.message);
      dispatch(getJobStatusData());
      setDeleteModal(false);
    } else {
      toast.error(jobStatusDeleteAPI.message);
    }
    dispatch(updateJobStatusSuccess([]));
  }, [jobStatusDeleteAPI]);

  //Delete Job Type
  const { jobTypeDeleteAPI } = useSelector((state) => ({
    jobTypeDeleteAPI: state.Jobs.jobTypeDelete,
  }));

  useEffect(() => {
    if (isEmpty(jobTypeDeleteAPI)) return;
    if (jobTypeDeleteAPI.status === 200) {
      toast.success(jobTypeDeleteAPI.message);
      dispatch(getJobsTypeData());
      setDeleteModal(false);
    } else {
      toast.error(jobTypeDeleteAPI.message);
    }
    dispatch(deleteJobTypeSuccess([]));
  }, [jobTypeDeleteAPI]);

  //Delete Job Priority
  const { jobPriorityDeleteAPI } = useSelector((state) => ({
    jobPriorityDeleteAPI: state.Jobs.jobPriorityDelete,
  }));

  useEffect(() => {
    if (isEmpty(jobPriorityDeleteAPI)) return;
    if (jobPriorityDeleteAPI.status === 200) {
      toast.success(jobPriorityDeleteAPI.message);
      dispatch(getJobsPriorityData());
      setDeleteModal(false);
    } else {
      toast.error(jobPriorityDeleteAPI.message);
    }
    dispatch(deleteJobPrioritySuccess([]));
  }, [jobPriorityDeleteAPI]);

  // Sort Data by active tab
  useEffect(() => {
    let data;
    if (activeTab === "1") {
      data = jobStatusListApi?.sort((a, b) => b.Id - a.Id);
      setStatusFlag(true);
    }
    if (activeTab === "2") {
      data = jobsTypeList?.sort((a, b) => b.Id - a.Id);
      setStatusFlag(false);
    }
    if (activeTab === "3") {
      data = jobPriorityList?.sort((a, b) => b.Id - a.Id);
      setStatusFlag(false);
    }
    if (activeTab === "4" || activeTab === "5") {
      data = [];
      setStatusFlag(false);
    }
    setStatusList(data);
  }, [jobStatusListApi, jobsTypeList, jobPriorityList, activeTab]);

  useEffect(() => {
    dispatch(getJobStatusData());
    dispatch(getJobsTypeData());
    dispatch(getJobsPriorityData());
  }, []);
  const Tabs = [
    {
      id: "1",
      name: "Statuses",
    },
    {
      id: "2",
      name: "Types",
    },
    {
      id: "3",
      name: "Priorities",
    },
    {
      id: "4",
      name: "Billable Items Templates",
    },
    // Change #100308 - Job Tags, put on a job by hand or by a form answer.
    {
      id: "5",
      name: "Tags",
    },
    // Change #100496 - PDF Designer designs on the Job Sheet button.
    {
      id: "6",
      name: "Job Sheets",
    },
  ];
  const [deleteModal, setDeleteModal] = useState(false);

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      FlagActive: updateItemStatus?.FlagActive,
      FlagInvoiceable: updateItemStatus?.FlagInvoiceable,
    };
    // Change #100482 - Job Status only, and only once the list has the
    // column, so an older backend never receives the key.
    if (
      activeTab === "1" &&
      updateItemStatus?.FlagAllowUnbilledClose !== undefined
    ) {
      updateNewStatus.FlagAllowUnbilledClose =
        updateItemStatus.FlagAllowUnbilledClose;
    }
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        // Job Status update

        dispatch(updateJobStatus([updateNewStatus]));
      }
      if (activeTab === "2") {
        // Job Type update
        dispatch(updateJobType([updateNewStatus]));
      }
      if (activeTab === "3") {
        // Job Priority update
        dispatch(updateJobPriority([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  // Update Job Status
  const { jobStatusUpdateAPI } = useSelector((state) => ({
    jobStatusUpdateAPI: state.Jobs.jobStatusUpdate,
  }));
  useEffect(() => {
    if (isEmpty(jobStatusUpdateAPI)) return;
    if (jobStatusUpdateAPI.status === 200) {
      toast.success(jobStatusUpdateAPI.message);
      dispatch(getJobStatusData());
    } else {
      toast.error(jobStatusUpdateAPI.message);
    }
    dispatch(updateJobStatusSuccess([]));
  }, [jobStatusUpdateAPI]);

  // Update Job Type
  const { jobTypeUpdateAPI } = useSelector((state) => ({
    jobTypeUpdateAPI: state.Jobs.jobTypeUpdate,
  }));
  useEffect(() => {
    if (isEmpty(jobTypeUpdateAPI)) return;
    if (jobTypeUpdateAPI.status === 200) {
      toast.success(jobTypeUpdateAPI.message);
      dispatch(getJobsTypeData());
    } else {
      toast.error(jobTypeUpdateAPI.message);
    }
    dispatch(updateJobTypeSuccess([]));
  }, [jobTypeUpdateAPI]);

  // Update Job Priority
  const { jobPriorityUpdateAPI } = useSelector((state) => ({
    jobPriorityUpdateAPI: state.Jobs.jobPriorityUpdate,
  }));
  useEffect(() => {
    if (isEmpty(jobPriorityUpdateAPI)) return;
    if (jobPriorityUpdateAPI.status === 200) {
      toast.success(jobPriorityUpdateAPI.message);
      dispatch(getJobsPriorityData());
    } else {
      toast.error(jobPriorityUpdateAPI.message);
    }
    dispatch(updateJobPrioritySuccess([]));
  }, [jobPriorityUpdateAPI]);

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteStatus}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
      />
      <SettingsPanel
        title="Job Settings"
        description="Statuses, types, priorities, billable item templates, tags and job sheet designs for jobs"
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        <TabContent activeTab={activeTab} className="pt-4">
          <TabPane tabId={+activeTab < 4 ? activeTab : "0"}>
            <StatusViewEditComponent
              statusList={statusList}
              setStatusList={setStatusList}
              createStatus={createStatus}
              setCreateStatus={setCreateStatus}
              handleCreateNewStatus={handleCreateNewStatus}
              setDeleteStatus={setDeleteStatus}
              setDeleteModal={setDeleteModal}
              setUpdateItemStatus={setUpdateItemStatus}
              statusFlag={statusFlag}
              allowUnbilledCloseFlag={statusFlag}
            />
          </TabPane>
          <TabPane tabId="4">
            <BillableItemsTemplates />
          </TabPane>
          <TabPane tabId="5">
            {activeTab === "5" && <JobTags />}
          </TabPane>
          <TabPane tabId="6">
            {activeTab === "6" && <JobSheets />}
          </TabPane>
        </TabContent>
      </SettingsPanel>
    </>
  );
}
